import { useDispatch, useSelector } from 'react-redux';
import { IonList, IonItem, IonCheckbox } from '@ionic/react';
import { updateUser } from '@/actions/user';
import Page from '@/pages/Page';

const NOTIFICATIONS = [
  {title: "New dirty load", value: "dirty"},
  {title: "Payment received", value: "accepted"},
  {title: "Customer picked up", value: "completed"},
  {title: "Customer hasn't picked up in 48 hours", value: "abandoned"},
];

export default function NotificationsPage() {
  const dispatch = useDispatch();
  const user = useSelector((store) => store.user);

  const enabled = (type, method) => _.includes(_.get(user, ['notifications', type]), method);
  const toggle = (type, method) => (e) => {
    const oldValue = _.get(user.notifications, type, []);
    const newValue = e.target.checked ? _.uniq([...oldValue, method]) : _.without(oldValue, method);
    dispatch(updateUser({notifications: {...(user.notifications || {}), [type]: newValue}}));
  };

  return (
    <Page title="Notifications" backDefault="/account">
      <p className="ion-padding">
        Select which notifications you wish to recieve. Texts will be sent to {user.phone_number}. You can
        turn them off at any time.
      </p>
      <IonList>
        {NOTIFICATIONS.map(({title, value}) => (
          <IonItem key={value}>
            {title}
            <IonCheckbox slot="end" checked={enabled(value, 'sms')} onIonChange={toggle(value, 'sms')}></IonCheckbox>
          </IonItem>
        ))}
      </IonList>
    </Page>
  );
}
